import { untrack } from 'svelte';

/**
 *
 *
 *
 *
 */
export function createBenefitTagState(getVariationId: () => string) {
    let lastVariationId = $state(untrack(getVariationId));
    let useVariationIdBenefit = $state(false);

    $effect(() => {
        const variationId = getVariationId();
        if (variationId !== lastVariationId) {
            useVariationIdBenefit = true;
            lastVariationId = variationId;
        }
    });

    return {
        get useVariationIdBenefit() {
            return useVariationIdBenefit;
        },
    };
}
